var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      attrs: { novalidate: "", disabled: _vm.loadingData },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return (() => {}).apply(null, arguments)
        },
      },
    },
    [
      _c(
        "v-row",
        { attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "8" } },
            [
              _c(
                "v-card",
                {
                  attrs: {
                    "max-width": "1200px",
                    flat: "",
                    color: "transparent",
                  },
                },
                [
                  _c(
                    "v-card-title",
                    [
                      _c("FormHeader", {
                        attrs: {
                          loading: _vm.loading,
                          link: "page-dictionaries",
                          title: _vm.getTitle
                            ? `${_vm.getTitle} справочник`
                            : `Создать справочник`,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-tabs",
                    {
                      model: {
                        value: _vm.activeTab,
                        callback: function ($$v) {
                          _vm.activeTab = $$v
                        },
                        expression: "activeTab",
                      },
                    },
                    _vm._l(_vm.$options.tabs, function (tab) {
                      return _c("v-tab", { key: tab.value }, [
                        _vm._v(" " + _vm._s(tab.title) + " "),
                      ])
                    }),
                    1
                  ),
                  _c(
                    "v-tabs-items",
                    {
                      model: {
                        value: _vm.activeTab,
                        callback: function ($$v) {
                          _vm.activeTab = $$v
                        },
                        expression: "activeTab",
                      },
                    },
                    [
                      _c(
                        "v-tab-item",
                        [
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "PageContent",
                                [
                                  _c(
                                    "v-container",
                                    [
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c("span", [_vm._v("Имя *")]),
                                              _c("v-text-field", {
                                                attrs: {
                                                  id: "name",
                                                  outlined: "",
                                                  autofocus: !_vm.fields.name,
                                                  "error-messages":
                                                    _vm.validationErrors.name,
                                                  disabled: _vm.loading,
                                                },
                                                model: {
                                                  value: _vm.fields.name,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.fields,
                                                      "name",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "fields.name",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c("span", [_vm._v("Метка *")]),
                                              _c("v-text-field", {
                                                attrs: {
                                                  id: "label",
                                                  outlined: "",
                                                  disabled: _vm.loading,
                                                  "error-messages":
                                                    _vm.validationErrors.label,
                                                },
                                                model: {
                                                  value: _vm.fields.label,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.fields,
                                                      "label",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "fields.label",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-tab-item",
                        [
                          _c(
                            "PageContent",
                            [
                              _c("DynamicListWrapper", {
                                attrs: {
                                  "multiple-creating": false,
                                  list: _vm.fields.dictionaryOptions,
                                  "error-messages": _vm.mixValidationErrors,
                                  "available-items":
                                    _vm.$options.availableDictionaryOptions,
                                  "copy-clipboard":
                                    _vm.mixCopyListItemClipboard,
                                  options: _vm.$options.options,
                                },
                                on: {
                                  "list-sort": _vm.mixListItemsReassort,
                                  add: _vm.mixCreateListItemHandler,
                                  option: _vm.mixListItemOptionHandler,
                                  "option-manual": _vm.optionPointHandler,
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "item",
                                    fn: function ({ data }) {
                                      return [
                                        _c(data.item.type, {
                                          tag: "component",
                                          attrs: { "list-item": data.item },
                                          on: {
                                            change: function ($event) {
                                              return _vm.mixListItemChangeHandler(
                                                $event,
                                                data.itemIndex
                                              )
                                            },
                                            "change-item": function ($event) {
                                              return _vm.mixListItemChangeItemHandler(
                                                $event,
                                                data.itemIndex
                                              )
                                            },
                                            "remove-item": function ($event) {
                                              return _vm.mixListItemRemoveItemHandler(
                                                $event,
                                                data.itemIndex
                                              )
                                            },
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "4" } },
            [
              _vm.isNew
                ? _c("ManageSidePanel", {
                    ref: "manageSidePanel",
                    attrs: {
                      isShowSortOrder: "",
                      "is-new": _vm.isNew,
                      "is-loading": _vm.loading,
                      language: _vm.language,
                      translations: _vm.fields.translations,
                      sortOrder: _vm.fields.sortOrder,
                    },
                    on: {
                      "update-translations": function ($event) {
                        return Object.assign(_vm.fields.translations, $event)
                      },
                      "language-update": function ($event) {
                        return _vm.$emit("language-update", $event)
                      },
                      cancel: function ($event) {
                        return _vm.$router.push({ name: "page-dictionaries" })
                      },
                      submit: _vm.submit,
                      "update-sort-order": function ($event) {
                        _vm.fields.sortOrder = Number($event)
                      },
                    },
                  })
                : _vm.data
                ? _c("ManageSidePanel", {
                    ref: "manageSidePanel",
                    attrs: {
                      isShowSortOrder: "",
                      "is-new": !_vm.data.id,
                      "created-at": _vm.data.createdAt,
                      "updated-at": _vm.data.updatedAt,
                      "is-loading": _vm.loading,
                      language: _vm.language,
                      translations: _vm.fields.translations,
                      "entity-id": _vm.data.id,
                      "entity-type": "dictionary",
                      sortOrder: _vm.fields.sortOrder,
                    },
                    on: {
                      delete: function ($event) {
                        return _vm.$emit("delete-dictionary")
                      },
                      cancel: function ($event) {
                        return _vm.$router.push({ name: "page-dictionaries" })
                      },
                      submit: _vm.submit,
                      "update-translations": function ($event) {
                        return Object.assign(_vm.fields.translations, $event)
                      },
                      "language-update": function ($event) {
                        return _vm.$emit("language-update", $event)
                      },
                      "update-sort-order": function ($event) {
                        _vm.fields.sortOrder = Number($event)
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }